module.exports = __webpack_public_path__ + "static/media/soundCloudIcon.0138f7ea.png";